import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.3 4H5.729A3.43 3.43 0 0 0 2.3 7.429v17.142A3.43 3.43 0 0 0 5.729 28H26.3a3.43 3.43 0 0 0 3.428-3.429V7.429A3.43 3.43 0 0 0 26.3 4m-.785 1.714-5.14 5.143h-5.721l5.143-5.143Zm-8.143 0-5.143 5.143H6.515l5.14-5.143ZM4.015 7.429a1.717 1.717 0 0 1 1.714-1.715h3.5l-5.141 5.143h-.073Zm24 17.143a1.717 1.717 0 0 1-1.714 1.714H5.729a1.717 1.717 0 0 1-1.714-1.715v-12h24Zm0-13.714h-5.217l4.67-4.67a1.7 1.7 0 0 1 .547 1.241Zm-14.7 13.526a1.41 1.41 0 0 0 1.472-.042l5.711-3.693a1.47 1.47 0 0 0 .66-1.269 1.45 1.45 0 0 0-.662-1.222l-5.713-3.643a1.4 1.4 0 0 0-1.472-.042 1.45 1.45 0 0 0-.725 1.258v7.389a1.45 1.45 0 0 0 .729 1.264m.986-8.143 4.88 3.188-4.88 3.188Z"
    }, null, -1)
  ])))
}
export default { render: render }